export const HALFPAGE_AD_HEIGHT = 600;

export const HALFPAGE_WRAPPER_DEFAULT_HEIGHT = 1800;

export const HALFPAGE_WRAPPER_MAX_HEIGHT: number =
  HALFPAGE_AD_HEIGHT + HALFPAGE_WRAPPER_DEFAULT_HEIGHT;

export const REPEATER_CONTENT = `<div class="sidebar-content sidebar-content--bottom sidebar-content--repeater" style="height: 1800px;">
    <!-- Vkládáno z JS default/box/ads/AdsRepeater.ts -->
    <!-- pozice - 313 / cat / new layout / halfpage_repeater -->
    <div class="cnc_side_ad_position"></div>
  </div>`;
